/// <reference path="../../../Modules/Attr/Dialog/NoboxEntityDialog.ts" />
namespace Nobox.Nobox {

    @Serenity.Decorators.registerClass()
    @Serenity.Decorators.panel()
    export class CampaignresultDialog extends NoboxEntityDialog<CampaignresultRow, any> {
        protected getFormKey() { return CampaignresultForm.formKey; }
        protected getIdProperty() { return CampaignresultRow.idProperty; }
        protected getLocalTextPrefix() { return CampaignresultRow.localTextPrefix; }
        protected getNameProperty() { return CampaignresultRow.nameProperty; }
        protected getService() { return CampaignresultService.baseUrl; }
        protected getDeletePermission() { return CampaignresultRow.deletePermission; }
        protected getInsertPermission() { return CampaignresultRow.insertPermission; }
        protected getUpdatePermission() { return CampaignresultRow.updatePermission; }

        protected form = new CampaignresultForm(this.idPrefix);
        private btnMessageCount: number = 0;
        private btnActionCount: number = 0;

        constructor(container?: JQuery) {
            super(container);
            this.initBtnList();
            this.form.BodyType.change(() => {
                var val = this.form.BodyType.get_value();
                if (!Q.isEmptyOrNull(val)) {
                    if (val == "0") {
                        this.form.BodyHtml.getGridField().toggle(false);
                        this.form.BodyText.getGridField().toggle(true);
                        Serenity.EditorUtils.setRequired(this.form.BodyHtml, false);
                        Serenity.EditorUtils.setRequired(this.form.BodyText, true);

                        this.buttonMessage(1, false);
                        this.buttonMessage(2, false);
                        this.buttonMessage(3, false);

                        this.buttonAction(1, false);
                        this.buttonAction(2, false);

                        this.form.ListMessage.getGridField().toggle(false);
                    } else if (val == "1") {
                        this.form.BodyHtml.getGridField().toggle(true);
                        this.form.BodyText.getGridField().toggle(false);
                        Serenity.EditorUtils.setRequired(this.form.BodyHtml, true);
                        Serenity.EditorUtils.setRequired(this.form.BodyText, false);

                        this.buttonMessage(1, false);
                        this.buttonMessage(2, false);
                        this.buttonMessage(3, false);

                        this.buttonAction(1, false);
                        this.buttonAction(2, false);

                        this.form.ListMessage.getGridField().toggle(false);
                    } else if (val == "2") {
                        this.form.BodyHtml.getGridField().toggle(false);
                        this.form.BodyText.getGridField().toggle(true);
                        Serenity.EditorUtils.setRequired(this.form.BodyHtml, false);
                        Serenity.EditorUtils.setRequired(this.form.BodyText, true);

                        //this.buttonMessage(1, true);
                        //this.buttonMessage(2, false);
                        //this.buttonMessage(3, false);
                        //this.form.ButtonCreate.getGridField().toggle(true);
                        this.form.ButtonActCreate.getGridField().toggle(false);
                        this.btnMessageCount = this.btnMessageCount == 0 ? 1 : this.btnMessageCount;
                        for (var i = 1; i <= 3; i++) {
                            if (i <= this.btnMessageCount) {
                                this.buttonMessage(i, true);
                            } else {
                                this.buttonMessage(i, false);
                            }
                        }

                        this.buttonAction(1, false);
                        this.buttonAction(2, false);

                        this.form.ListMessage.getGridField().toggle(false);
                    } else if (val == "3") {
                        this.form.BodyHtml.getGridField().toggle(false);
                        this.form.BodyText.getGridField().toggle(true);
                        Serenity.EditorUtils.setRequired(this.form.BodyHtml, false);
                        Serenity.EditorUtils.setRequired(this.form.BodyText, true);

                        this.buttonMessage(1, false);
                        this.buttonMessage(2, false);
                        this.buttonMessage(3, false);

                        this.btnActionCount = this.btnActionCount == 0 ? 1 : this.btnActionCount;
                        this.form.ButtonCreate.getGridField().toggle(false);
                        for (var i = 1; i <= 2; i++) {
                            if (i <= this.btnActionCount) {
                                this.buttonAction(i, true);
                            } else {
                                this.buttonAction(i, false);
                            }
                        }

                        this.form.ListMessage.getGridField().toggle(false);
                    } else if (val == "4") {
                        this.form.BodyHtml.getGridField().toggle(false);
                        this.form.BodyText.getGridField().toggle(true);
                        Serenity.EditorUtils.setRequired(this.form.BodyHtml, false);
                        Serenity.EditorUtils.setRequired(this.form.BodyText, true);

                        this.buttonMessage(1, false);
                        this.buttonMessage(2, false);
                        this.buttonMessage(3, false);


                        this.buttonAction(1, false);
                        this.buttonAction(2, false);

                        this.form.ListMessage.getGridField().toggle(true);
                        this.viewBtnList();

                    }
                }
            });

            this.form.ButtonActType.change(() => {
                var value = this.form.ButtonActType.value;
                if (value == "url") {
                    Serenity.EditorUtils.setValue(this.form.ButtonAct1Type, "call");
                    this.form.ButtonAct.element.attr("placeholder", "ex https://nobox.ai");
                    this.form.ButtonAct1.element.attr("placeholder", "ex 6282747687643");

                    this.form.ButtonActText.element.attr("placeholder", "ex Websites");
                    this.form.ButtonAct1Text.element.attr("placeholder", "ex Call Me");
                } else {
                    Serenity.EditorUtils.setValue(this.form.ButtonAct1Type, "url");
                    this.form.ButtonAct1.element.attr("placeholder", "ex https://nobox.ai");
                    this.form.ButtonAct.element.attr("placeholder", "ex 6282747687643");

                    this.form.ButtonAct1Text.element.attr("placeholder", "ex Websites");
                    this.form.ButtonActText.element.attr("placeholder", "ex Call Me");
                }
            });

            this.form.ButtonAct1Type.change(() => {
                var value = this.form.ButtonAct1Type.value;
                if (value == "url") {
                    Serenity.EditorUtils.setValue(this.form.ButtonActType, "call");
                    this.form.ButtonAct1.element.attr("placeholder", "ex https://nobox.ai");
                    this.form.ButtonAct.element.attr("placeholder", "ex 6282747687643");

                    this.form.ButtonAct1Text.element.attr("placeholder", "ex Websites");
                    this.form.ButtonActText.element.attr("placeholder", "ex Call Me");
                } else {
                    Serenity.EditorUtils.setValue(this.form.ButtonActType, "url");
                    this.form.ButtonAct.element.attr("placeholder", "ex https://nobox.ai");
                    this.form.ButtonAct1.element.attr("placeholder", "ex 6282747687643");

                    this.form.ButtonActText.element.attr("placeholder", "ex Websites");
                    this.form.ButtonAct1Text.element.attr("placeholder", "ex Call Me");
                }
            });

            this.buttonMessageClose();
            this.buttonActionClose();

            this.form.ButtonCreate.element.find(".btn").on("click", () => {
                this.btnMessageCount++;
                this.buttonMessage(this.btnMessageCount, true);
            })

            this.form.ButtonActCreate.element.find(".btn").on("click", () => {
                this.btnActionCount++;
                this.buttonAction(this.btnActionCount, true);
            })

            var pageX;
            var pageY;
            $("body").find("ul.tools").remove();
            $("body").append(`<ul class="tools">
                <li title="Italic selected text"><i class="fa fa-italic"></i></li>
                <li title="Bold selected text"><i class="fa fa-bold"></i></li>
                <li title="Strikethrough selected text"><i class="fa fa-strikethrough"></i></li>
                <li title="Monospace selected text">M</li>
            </ul>`);

            $("ul.tools li").eq(0).click(() => {
                this.setCharSelected(this.form.BodyText.element, '_');
                if ($('ul.tools').is(":visible")) {
                    $('ul.tools').fadeOut(200);
                }
            });
            $("ul.tools li").eq(1).click(() => {
                this.setCharSelected(this.form.BodyText.element, '*');
                if ($('ul.tools').is(":visible")) {
                    $('ul.tools').fadeOut(200);
                }
            });
            $("ul.tools li").eq(2).click(() => {
                this.setCharSelected(this.form.BodyText.element, '~');
                if ($('ul.tools').is(":visible")) {
                    $('ul.tools').fadeOut(200);
                }
            });
            $("ul.tools li").eq(3).click(() => {
                this.setCharSelected(this.form.BodyText.element, '```');
                if ($('ul.tools').is(":visible")) {
                    $('ul.tools').fadeOut(200);
                }
            });
            this.form.BodyText.element.bind("mouseup", () => {
                var selectedText = this.getSelected(this.form.BodyText.element);
                if ($('ul.tools').is(":visible")) {
                    $('ul.tools').fadeOut(200);
                } else {
                    if (selectedText != '') {
                        $('ul.tools').css({
                            'left': pageX + 5,
                            'top': pageY - 55
                        }).fadeIn(200);
                    } else {
                        $('ul.tools').fadeOut(200);
                    }
                }
            });
            this.form.BodyText.element.on("mousedown", function (e) {
                pageX = e.pageX;
                pageY = e.pageY;
            });
        }

        viewBtnList() {
            if (Q.isEmptyOrNull(this.form.InteractiveMsg.value)) {
                this.form.ListMessage.getGridField().find(".btn-list-edit").hide();
                this.form.ListMessage.getGridField().find(".btn-list-add").show();
            } else {
                var arr = JSON.parse(this.form.InteractiveMsg.value);
                if (arr[0].rows != undefined) {
                    this.form.ListMessage.getGridField().find(".btn-list-edit").show();
                    this.form.ListMessage.getGridField().find(".btn-list-add").hide();
                } else {
                    this.form.ListMessage.getGridField().find(".btn-list-edit").hide();
                    this.form.ListMessage.getGridField().find(".btn-list-add").show();
                }
            }
        }

        initBtnList() {
            this.form.ListMessage.getGridField().find(".btn-list-add").on("click", () => {
                var dlg = new CampaignListMessageDialog();
                dlg.saveCallback = (res) => {
                    this.form.InteractiveMsg.value = res;
                    this.viewBtnList();
                }
                dlg.loadNewAndOpenDialog();
            });
            this.form.ListMessage.getGridField().find(".btn-list-edit").on("click", () => {
                var dlg = new CampaignListMessageDialog();
                dlg.setEditMode(this.form.InteractiveMsg.value);
                dlg.saveCallback = (res) => {
                    this.form.InteractiveMsg.value = res;
                }
                dlg.loadNewAndOpenDialog();
            });
            this.form.ListMessage.getGridField().find(".btn-list-view").on("click", () => {

            });
        }

        getSaveEntity() {
            var resEntity = {} as CampaignresultRow;
            var entity = super.getSaveEntity() as any;
            resEntity = this.mappingEntity(entity);
            if (entity.BodyType == "2") {
                var buttons = [];
                for (var i = 1; i <= this.btnMessageCount; i++) {
                    var indexBtn = i - 1;
                    buttons.push({
                        buttonId: `id${i}`,
                        buttonText: {
                            displayText: entity[`Button${indexBtn == 0 ? "" : indexBtn}`]
                        },
                        type: 1
                    })
                }
                resEntity.InteractiveMsg = JSON.stringify(buttons);
            } else if (entity.BodyType == "3") {
                var buttons = [];
                for (var i = 1; i <= this.btnActionCount; i++) {
                    var indexBtn = i - 1;
                    var text = entity[`ButtonAct${indexBtn == 0 ? "" : indexBtn}Text`];
                    var value = entity[`ButtonAct${indexBtn == 0 ? "" : indexBtn}`];
                    var type = entity[`ButtonAct${indexBtn == 0 ? "" : indexBtn}Type`];
                    if (type == "url") {
                        buttons.push(this.urlBtn(i, text, value));
                    } else if (type == "call") {
                        buttons.push(this.callBtn(i, text, value));
                    }
                }
                resEntity.InteractiveMsg = JSON.stringify(buttons);
            } else {
            }
            return resEntity;
        }

        urlBtn(index, text, url) {
            var btn = { index: index, urlButton: { displayText: text, url: url } };
            return btn;
        }

        callBtn(index, text, phone) {
            var btn = { index: index, callButton: { displayText: text, phoneNumber: phone } };
            return btn;
        }

        mappingEntity(item: any): CampaignresultRow {
            var resEntity = {} as CampaignresultRow;
            resEntity.IsRead = item.IsRead;
            resEntity.ReadDate = item.ReadDate;
            resEntity.Email = item.Email;
            resEntity.ProcessBy = item.ProcessBy;
            resEntity.Attachment = item.Attachment;
            resEntity.Body = item.Body;
            resEntity.BodyHtml = item.BodyHtml;
            resEntity.BodyText = item.BodyText;
            resEntity.BodyType = item.BodyType;
            resEntity.ChannelId = item.ChannelId;
            resEntity.Id = item.Id;
            resEntity.InteractiveMsg = item.InteractiveMsg;
            resEntity.Unik = item.Unik;
            resEntity.ShortLink = item.ShortLink;
            resEntity.Status = item.Status;
            resEntity.Subject = item.Subject;
            resEntity.Tags = item.Tags;

            return resEntity;
        }

        setButtonMessage(json) {
            var button = JSON.parse(json) as [{
                buttonId: string,
                buttonText: {
                    displayText: string,
                }
                type: number
            }];
            this.btnMessageCount = button.length;
            button.forEach((x, i) => {
                this.form[`Button${i == 0 ? "" : i}`].value = x.buttonText.displayText;
            });
        }

        setButtonAction(json) {
            var button = JSON.parse(json) as [];
            this.btnActionCount = button.length;
            button.forEach((x, i) => {
                var text = this.form[`ButtonAct${i == 0 ? "" : i}Text`];
                var value = this.form[`ButtonAct${i == 0 ? "" : i}`];
                var type = this.form[`ButtonAct${i == 0 ? "" : i}Type`];
                if (x["callButton"] != undefined) {
                    Serenity.EditorUtils.setValue(type, "call");
                    text.value = x["callButton"]["displayText"];
                    value.value = x["callButton"]["phoneNumber"];
                } else if (x["urlButton"] != undefined) {
                    Serenity.EditorUtils.setValue(type, "url");
                    text.value = x["urlButton"]["displayText"];
                    value.value = x["urlButton"]["url"];
                }
            });
        }

        buttonMessage(number: number, hidden: boolean) {
            if (hidden) {
                this.form.ButtonActCreate.getGridField().toggle(false);

                this.form.ButtonAct.getGridField().toggle(false);
                this.form.ButtonActClose.getGridField().toggle(false);
                this.form.ButtonActText.getGridField().toggle(false);
                this.form.ButtonActType.getGridField().toggle(false);
                Serenity.EditorUtils.setRequired(this.form.ButtonActType, false);
                Serenity.EditorUtils.setRequired(this.form.ButtonActText, false);
                Serenity.EditorUtils.setRequired(this.form.ButtonAct, false);

                this.form.ButtonAct1.getGridField().toggle(false);
                this.form.ButtonAct1Close.getGridField().toggle(false);
                this.form.ButtonAct1Text.getGridField().toggle(false);
                this.form.ButtonAct1Type.getGridField().toggle(false);
                Serenity.EditorUtils.setRequired(this.form.ButtonAct1Type, false);
                Serenity.EditorUtils.setRequired(this.form.ButtonAct1Text, false);
                Serenity.EditorUtils.setRequired(this.form.ButtonAct1, false);
            }
            if (number == 1) {
                //this.btnMessageCount = hidden ? 1 : 0;
                this.form.ButtonCreate.getGridField().toggle(hidden);

                this.form.Button.getGridField().toggle(hidden);
                this.form.ButtonClose.getGridField().toggle(hidden);
                Serenity.EditorUtils.setRequired(this.form.Button, hidden);
            } else if (number == 2) {
                this.form.Button1Close.getGridField().toggle(hidden);
                this.form.Button1.getGridField().toggle(hidden);
                Serenity.EditorUtils.setRequired(this.form.Button1, hidden);
            } else if (number == 3) {
                if (this.form.BodyType.value == "2") {
                    this.form.ButtonCreate.getGridField().toggle(!hidden);
                }
                if (hidden) {
                    this.form.Button1CloseHide.getGridField().toggle(hidden);
                    this.form.Button1Close.getGridField().toggle(!hidden);
                } else {
                    if (this.btnMessageCount == 3) {
                        this.form.Button1CloseHide.getGridField().toggle(hidden);
                        this.form.Button1Close.getGridField().toggle(!hidden);
                    }
                }

                this.form.Button2.getGridField().toggle(hidden);
                this.form.Button2Close.getGridField().toggle(hidden);
                Serenity.EditorUtils.setRequired(this.form.Button2, hidden);
            }
        }

        buttonMessageClose() {
            this.form.Button1Close.element.on("click", () => {
                this.buttonMessage(this.btnMessageCount, false);
                this.btnMessageCount--;
            })
            this.form.Button2Close.element.on("click", () => {
                this.buttonMessage(this.btnMessageCount, false);
                this.btnMessageCount--;
            })
        }

        buttonActionClose() {
            this.form.ButtonAct1Close.element.on("click", () => {
                this.buttonAction(this.btnActionCount, false);
                this.btnActionCount--;
            })
        }

        buttonAction(number: number, hidden: boolean) {
            if (hidden) {
                this.form.ButtonCreate.getGridField().toggle(false);
                this.form.Button.getGridField().toggle(false);
                this.form.ButtonClose.getGridField().toggle(false);

                this.form.Button1Close.getGridField().toggle(false);
                this.form.Button1.getGridField().toggle(false);

                this.form.Button2.getGridField().toggle(false);
                this.form.Button2Close.getGridField().toggle(false);

                Serenity.EditorUtils.setRequired(this.form.Button, false);
                Serenity.EditorUtils.setRequired(this.form.Button1, false);
                Serenity.EditorUtils.setRequired(this.form.Button2, false);
            }
            if (number == 1) {
                //this.btnActionCount = hidden ? 1 : 0;
                this.form.ButtonActCreate.getGridField().toggle(hidden);

                this.form.ButtonAct.getGridField().toggle(hidden);
                this.form.ButtonActClose.getGridField().toggle(hidden);
                this.form.ButtonActText.getGridField().toggle(hidden);
                this.form.ButtonActType.getGridField().toggle(hidden);
                Serenity.EditorUtils.setRequired(this.form.ButtonActType, hidden);
                Serenity.EditorUtils.setRequired(this.form.ButtonActText, hidden);
                Serenity.EditorUtils.setRequired(this.form.ButtonAct, hidden);
            } else if (number == 2) {
                if (this.form.BodyType.value == "3") {
                    this.form.ButtonActCreate.getGridField().toggle(!hidden);
                }

                this.form.ButtonAct1.getGridField().toggle(hidden);
                this.form.ButtonAct1Close.getGridField().toggle(hidden);
                this.form.ButtonAct1Text.getGridField().toggle(hidden);
                this.form.ButtonAct1Type.getGridField().toggle(hidden);
                Serenity.EditorUtils.setRequired(this.form.ButtonAct1Type, hidden);
                Serenity.EditorUtils.setRequired(this.form.ButtonAct1Text, hidden);
                Serenity.EditorUtils.setRequired(this.form.ButtonAct1, hidden);
            }
        }

        getSelected(textArea) {
            var text = textArea[0].value;
            var indexStart = textArea[0].selectionStart;
            var indexEnd = textArea[0].selectionEnd;
            return text.substring(indexStart, indexEnd);
        }

        setCharSelected(textArea, char) {
            var text = textArea[0].value;
            var indexStart = textArea[0].selectionStart;
            var indexEnd = textArea[0].selectionEnd;
            var text1 = this.addStr(text, indexStart, char);
            var text2 = this.addStr(text1, indexEnd + char.length, char);
            textArea[0].value = text2;
        }

        addStr(str, index, stringToAdd) {
            return str.substring(0, index) + stringToAdd + str.substring(index, str.length);
        }

        protected updateInterface() {
            super.updateInterface();
            var item = this.get_entity();
            if (this.isEditMode()) {
                if (item.BodyType == 0 || item.BodyType == 2 || item.BodyType == 3 || item.BodyType == 4) {
                    this.form.BodyHtml.getGridField().toggle(false);
                    this.form.BodyText.getGridField().toggle(true);
                    this.form.BodyText.value = item.Body;
                    Serenity.EditorUtils.setRequired(this.form.BodyText, true);
                } else if (item.BodyType == 1) {
                    this.form.BodyHtml.getGridField().toggle(true);
                    this.form.BodyText.getGridField().toggle(false);
                    this.form.BodyHtml.set_value(item.Body);
                    Serenity.EditorUtils.setRequired(this.form.BodyHtml, true);
                    Serenity.EditorUtils.setRequired(this.form.BodyText, false);
                }

                if (item.ContactId != 0) {
                    this.form.ContactId.getGridField().toggle(true);
                    this.form.Group.getGridField().toggle(false);
                } else {
                    this.form.ContactId.getGridField().toggle(false);
                    this.form.Group.getGridField().toggle(true);
                }

                if (item.BodyType == BodyType.BodyTypeEnum.QuickReply) {
                    this.setButtonMessage(item.InteractiveMsg);

                    for (var i = 1; i <= 3; i++) {
                        if (i <= this.btnMessageCount) {
                            this.buttonMessage(i, true);
                        } else {
                            this.buttonMessage(i, false);
                        }
                    }
                }
                if (item.BodyType == BodyType.BodyTypeEnum.CallToAction) {
                    this.setButtonAction(item.InteractiveMsg);
                    for (var i = 1; i <= 2; i++) {
                        if (i <= this.btnActionCount) {
                            this.buttonAction(i, true);
                        } else {
                            this.buttonAction(i, false);
                        }
                    }
                }

                if (item.BodyType == BodyType.BodyTypeEnum.List) {
                    this.form.ListMessage.getGridField().toggle(true);
                    this.viewBtnList();
                }
            }
        }

        protected save(callback) {
            super.save(callback);
        }
    }
}